import { EDealType, EEntityType, IAddFavoriteRequest } from '../../../shared/repositories/favorites/v1/add-favorite';
import { IDeleteOfferFromFavoritesRequest } from '../../../shared/repositories/favorites/v1/delete-offer-from-favorites';
import { getGaLabel, getNewbuildingId } from '../../../shared/selectors/newbuilding';
import { IFavoriteActionTypes } from '../../../shared/types/analytics/favorite';
import { TThunkAction } from '../../../shared/types/redux/thunk';
import { addFavorite } from './addFavorite';
import { removeFavorite } from './removeFavorite';

export function changeFavorite(newFavoriteState: boolean, eventActions?: IFavoriteActionTypes): TThunkAction {
  return async (dispatch, getState) => {
    const state = getState();
    const newbuildingId = getNewbuildingId(state);
    const gaLabel = getGaLabel(state);

    const parameters = {
      dealType: EDealType.Sale,
      entityType: EEntityType.Newbuilding,
      entityId: newbuildingId,
    } as IAddFavoriteRequest & IDeleteOfferFromFavoritesRequest;

    const action = newFavoriteState ? addFavorite : removeFavorite;

    dispatch(action(gaLabel, parameters, eventActions));
  };
}
